var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWavyCheck = function SvgWavyCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7543 3.45879C11.4721 2.84707 12.5279 2.84707 13.2457 3.45879L14.4667 4.49929C14.7743 4.76143 15.1567 4.91985 15.5596 4.952L17.1587 5.07961C18.0988 5.15463 18.8454 5.90117 18.9204 6.8413L19.048 8.4404C19.0802 8.84327 19.2386 9.22573 19.5007 9.53333L20.5412 10.7543C21.1529 11.4721 21.1529 12.5279 20.5412 13.2457L19.5007 14.4667C19.2386 14.7743 19.0802 15.1567 19.048 15.5596L18.9204 17.1587C18.8454 18.0988 18.0988 18.8454 17.1587 18.9204L15.5596 19.048C15.1567 19.0802 14.7743 19.2386 14.4667 19.5007L13.2457 20.5412C12.5279 21.1529 11.4721 21.1529 10.7543 20.5412L9.53333 19.5007C9.22573 19.2386 8.84327 19.0802 8.4404 19.048L6.8413 18.9204C5.90117 18.8454 5.15463 18.0988 5.07961 17.1587L4.952 15.5596C4.91985 15.1567 4.76143 14.7743 4.49929 14.4667L3.45879 13.2457C2.84707 12.5279 2.84707 11.4721 3.45879 10.7543L4.49929 9.53333C4.76143 9.22573 4.91985 8.84327 4.952 8.4404L5.07961 6.8413C5.15463 5.90117 5.90117 5.15463 6.8413 5.07961L8.4404 4.952C8.84327 4.91985 9.22573 4.76143 9.53333 4.49929L10.7543 3.45879Z",
    fill: "#E9E8E8",
    stroke: "#E9E8E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10L11 14L9 12",
    stroke: "#32302F",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgWavyCheck;